module.exports = __webpack_public_path__ + "img/shopBj.5418bdc9.png";